// Google Ads conversion event helper.
//
// window.gtag is created by the GA4 inline snippet in index.html. That
// snippet has NO production-hostname gate (GA4 runs in dev too), so
// window.gtag EXISTS in local dev — the hostname gate lives here instead:
// the Google Ads tag is only config'd on nanorhino.com, and this helper
// returns early everywhere else so dev/smoke runs never send conversions
// that would feed ad bidding.
//
// Funnel events:
//   tdee_result_viewed — first TDEE result rendered (result_payload SSE)
//   plan_generated     — in-chat plan stream completed successfully
//   trial_started      — CTA conversion (SMS click or email submit success)

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void
  }
}

type AdsConversionEvent = 'tdee_result_viewed' | 'plan_generated' | 'trial_started'

// send_to conversion labels from the Google Ads UI (Goals → Conversions).
const SEND_TO: Record<AdsConversionEvent, string> = {
  tdee_result_viewed: 'AW-17881085582/HZdECPPjxb0cEI7trs5C',
  plan_generated: 'AW-17881085582/KdkhCKXNyb0cEI7trs5C',
  trial_started: 'AW-17881085582/_tciCN-Ur70cEI7trs5C',
}

// Once per session: every funnel layer counts deduped user behavior, so
// recalculating TDEE, regenerating the plan, or re-clicking the CTA doesn't
// inflate conversion counts.
export function trackAdsConversionOnce(event: AdsConversionEvent) {
  if (window.location.hostname !== 'nanorhino.com') return
  const key = `gads_${event}`
  try {
    if (sessionStorage.getItem(key)) return
    sessionStorage.setItem(key, '1')
  } catch {
    // sessionStorage unavailable (private mode etc.) — still send the event.
  }
  window.gtag?.('event', 'conversion', { send_to: SEND_TO[event] })
}
